import { HeadingWithButtons } from "components";
import * as React from 'react';
export default {
  HeadingWithButtons,
  React
};